import { useRouter } from 'next/router';

import Button from '~/src/common/components/Button';
import Icon from '~/src/common/components/Icon';

import * as S from './layout';

interface Props {
  title?: string;
  text: string;
  button?: string;
}

const EmptyLarge = ({ title, text, button }: Props) => {
  const router = useRouter();
  const goHome = () => void router.push('/');

  return (
    <S.EmptyLargeContainer>
      <Icon name="Empty" />
      {title ? <h2>{title}</h2> : null}
      <p>{text}</p>
      {button ? <Button onClick={goHome}>{button}</Button> : null}
    </S.EmptyLargeContainer>
  );
};

export default EmptyLarge;
